export function createCarouselNavClickParams(currentPage, increment, totalSize, direction) {
    var _a;
    var params = (_a = {},
        _a["Index" /* InstrumentationParam.Index */] = currentPage.toString(),
        _a["Increment" /* InstrumentationParam.Increment */] = increment.toString(),
        _a["TotalSize" /* InstrumentationParam.TotalSize */] = totalSize.toString(),
        _a["ElementId" /* InstrumentationParam.ElementId */] = direction < 0 ? 'NavPrevious' : 'NavNext',
        _a);
    return params;
}
//# sourceMappingURL=CarouselLogHelpers.js.map